import { IResearchWorkItem, ResearchStageEnum } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IResearchTransitionRequest {
  workItemId: string;
  version: number;
  toStage: ResearchStageEnum;
  reason?: string;
}

export const transitionResearchWorkItem = async ({
  workItemId,
  version,
  toStage,
  reason,
}: IResearchTransitionRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/transition`,
    { version, toStage, reason }
  );

  return response.data;
};
